// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".init-org-cert-dialog.common-dialog[data-v-ce8d3f8e] .el-dialog{width:var(--common-dialog-width)}.init-org-cert-dialog.common-dialog .el-form[data-v-ce8d3f8e]{margin-right:var(--common-dialog-right)}", ""]);
// Exports
module.exports = exports;
